import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { failedResponses } from '../errors/responses';

const c = initContract();

export const ManagementResponse = z.object({
  status: z.string()
});

export type ManagementResponse = z.infer<typeof ManagementResponse>;

export default c.router({
  submitLeaverRequest: {
    method: 'POST',
    path: '/halos/leaver',
    responses: {
      200: ManagementResponse,
      ...failedResponses
    },
    body: z.object({
      customerName: z.string().nonempty(),
      fullName: z.string().nonempty(),
      personalEmail: z.string().email().nonempty(),
      workEmail: z.string().optional(),
      mobileNumber: z.string().nonempty(),
      devicesToBeCollected: z.array(z.string().nonempty()),
      collectionAddress: z.string().nonempty(),
      canPrintLabel: z.boolean().optional(),
      expediteCollection: z.boolean().optional(),
      targetDate: z.string(),
      notes: z.string().optional()
    })
  },
  submitWarrantyRequest: {
    method: 'POST',
    path: '/halos/warranty',
    responses: {
      200: ManagementResponse,
      ...failedResponses
    },
    body: z.object({
      customerName: z.string().nonempty(),
      modelAndManufacturer: z.string().nonempty(),
      serialNumber: z.string().nonempty(),
      userFullName: z.string().nonempty(),
      userAddress: z.string().nonempty(),
      workEmailAddress: z.string().email().nonempty(),
      mobileNumber: z.string().nonempty(),
      canPrintLabel: z.boolean().optional(),
      notes: z.string().optional()
    })
  },
  submitStockProvisionRequest: {
    method: 'POST',
    path: '/halos/stockProvision',
    responses: {
      200: ManagementResponse,
      ...failedResponses
    },
    body: z.object({
      customerName: z.string().nonempty(),
      bundle: z.string().optional(),
      products: z.array(z.object({ name: z.string(), quantity: z.number(), sku: z.string() })),
      userFullName: z.string().nonempty(),
      userAddress: z.string().nonempty(),
      workEmailAddress: z.string().email().nonempty(),
      personalEmailAddress: z.string().optional(),
      mobileNumber: z.string().nonempty(),
      notes: z.string().optional()
    })
  },
  submitStockReportingRequest: {
    method: 'POST',
    path: '/halos/stockReporting',
    responses: {
      200: ManagementResponse,
      ...failedResponses
    },
    body: z.object({
      customerName: z.string().nonempty()
    })
  },
  submitInvoiceRequest: {
    method: 'POST',
    path: '/halos/invoice',
    responses: {
      200: ManagementResponse,
      ...failedResponses
    },
    body: z.object({
      customerName: z.string().nonempty()
    })
  }
});
